<template>
    <div>
        <b-modal ref="payment" id="payment" title="Payments" size="xl" @hidden="closing" centered>
            <b-row v-if="!loading">
                <div class="col-sm-12 col-md-6">
                    <dl>
                        <dt><h6>Payment History</h6></dt>
                        <dd>
                            <table class="table table-responsive-sm">
                                <thead>
                                    <th>item</th>
                                    <th>Amount</th>
                                    <th></th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Total Game Price</td>
                                        <td>£{{ totalPrice }}</td>
                                        <td></td>
                                    </tr>
                                    <template v-if="booking.payments && booking.payments.length">
                                        <tr v-for="payment in booking.payments">
                                            <td>Payment {{ formatDateTime(payment.created_at) }}</td>
                                            <td>{{ (payment.amount / 100).toFixed(2) }}</td>
                                            <td>
                                                <b-button type="button" variant="danger" @click="removePayment(payment)"><i class="fas fa-fw fa-times"></i></b-button>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td colspan="3" class="text-center">
                                                No Payments
                                            </td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td>Remaining Amount</td>
                                        <td>£{{ remainingAmount }}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </dd>
                    </dl>
                </div>
                <div class="col-sm-12 col-md-6">
                    <dl>
                        <dt><h6>Add Payment</h6></dt>
                        <dd>
                            <b-form @submit.prevent="submitPayment">
                                <b-form-group label="Amount">
                                    <b-input-group>
                                        <b-input-group-prepend>
                                            <b-input-group-text>£</b-input-group-text>
                                        </b-input-group-prepend>
                                        <b-form-input v-model="payment.amount" type="number" step=".01" required :disabled="remainingAmount == '0.00'"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-button type="submit" variant="primary" block class="mb-2" :disabled="remainingAmount == '0.00'">Submit Payment</b-button>
                            </b-form>
                            <b-button @click="payFull" type="button" variant="success" block class="mb-2" :disabled="remainingAmount == '0.00'">Paid In Full</b-button>
                        </dd>
                    </dl>
                </div>
            </b-row>
            <template #modal-footer="{  }"><div></div></template>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment-timezone';
export default {
    props: {
        bookingRaw: {
            default: false,
        },
    },
    data() {
        return {
            booking: false,
            loading: false,
            loaded: false,
            payment: {
                amount: 0,
                booking_id: this.bookingId,
            },
        };
    },
    computed: {
        bookingId() {
            return (this.booking) ? this.booking.id : false;
        },
        totalPrice() {
            let price = (this.booking.free_pass) ? 0 : this.booking.price;
            if (this.booking.rentals && this.booking.rentals.length) {
                this.booking.rentals.forEach((rental) => {
                    price += rental.rental_type.price;
                });
            }

            return (price / 100).toFixed(2);
        },
        remainingAmount() {
            let price = (this.booking.free_pass) ? 0 : this.booking.price;
            if (this.booking.rentals && this.booking.rentals.length) {
                this.booking.rentals.forEach((rental) => {
                    price += rental.rental_type.price;
                });
            }

            let paid = 0;
            if (this.booking.payments && this.booking.payments.length) {
                this.booking.payments.forEach((payment) => {
                    paid += payment.amount;
                });
            }

            return ((price - paid) / 100).toFixed(2);
        },
    },
    methods: {
        payFull() {
            this.payment.amount = this.remainingAmount;
            this.submitPayment(true);
        },
        submitPayment(close = false) {
            this.loading = true;
            this.payment.amount = this.payment.amount * 100;
            axios.post(this.$routes.route('payment.store'), this.payment)
                .then(response => {
                    this.payment = {
                        amount: 0,
                        booking_id: this.booking.id,
                    };

                    if (close) {
                        this.$refs.payment.hide();
                    }

                    this.init();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        removePayment(payment) {
            this.loading = true;
            axios.delete(this.$routes.route('payment.destroy', {payment: payment.id}))
                .then(response => {
                    this.init();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        formatDateTime(dateTime) {
            return moment(dateTime).format('DD/MM/YYYY HH:mm');
        },
        closing() {
            this.$emit('closing');
        },
        init() {
            if (this.bookingRaw) {
                this.booking = this.bookingRaw;

                this.payment.booking_id = this.booking.id;

                axios.get(this.$routes.route('booking.show', {booking: this.booking.id}))
                    .then(response => {
                        this.booking = response.data;
                        this.loading = false;
                        this.loaded = true;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
    },
    mounted() {
        this.loading = true;
        this.init();
    },
}
</script>